import { render, staticRenderFns } from "./addBrand.vue?vue&type=template&id=48385f72&scoped=true"
import script from "./addBrand.vue?vue&type=script&lang=js"
export * from "./addBrand.vue?vue&type=script&lang=js"
import style0 from "./addBrand.vue?vue&type=style&index=0&id=48385f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48385f72",
  null
  
)

export default component.exports